import { render, staticRenderFns } from "./CombinationsSeparatedBoxes.vue?vue&type=template&id=f8e75024&scoped=true"
import script from "./CombinationsSeparatedBoxes.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsSeparatedBoxes.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsSeparatedBoxes.vue?vue&type=style&index=0&id=f8e75024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e75024",
  null
  
)

export default component.exports